import { Component, OnDestroy, OnInit } from '@angular/core';
import { ITab } from '../../controls/tab/tab.component';
import { ActivatedRoute } from '@angular/router';
import { DocumentService } from '../shared/services/document.service';
import { IApiResponse } from '../../../shared/models/api-response';
import { ISimPublicationMetadata } from '../shared/models/document-publication-metadata';
import { ISimPublicationOverview } from '../shared/models/document-publication-overview';
import { filter, map, Subscription, switchMap, tap } from 'rxjs';
import { ISimPublicationDetails } from '../shared/models/document-publication-details';
import { tabIds } from '../../../shared/constants/sa-library-constants';
import { ISimPublicationKeyDates } from '../shared/models/document-publication-keyDates';
@Component({
    selector: 'app-document-details',
    templateUrl: './document-details.component.html',
    styleUrl: './document-details.component.scss',
    standalone: false
})
export class DocumentDetailsComponent implements OnInit, OnDestroy{
  SIMPublicationMetadata: ISimPublicationMetadata | null = null;
  SIMPublicationOverview: ISimPublicationOverview | null = null;
  SIMPublicationDetails: ISimPublicationDetails | null = null;
  SIMPublicationKeyDates: ISimPublicationKeyDates | null = null;
  designation: string = '';
  title: string = '';
  documentUri: string = '';
  loading: boolean = true;
  selectedTab: string = tabIds.Overview;
  tabIds = tabIds;
  subscriptions: Subscription = new Subscription();
  tabs: ITab[] = [
    { id: 'Overview', label: 'Overview' },
    { id: 'Details', label: 'Details' },
    { id: 'KeyDates', label: 'Key Dates' }
  ];

  constructor(
    private _route: ActivatedRoute,
    private _documentService: DocumentService,
  ) {}

  ngOnInit(): void{
    this.initialize();
  }

  initialize(): void {
    const documentMetadata = this._route.params.pipe(
      map(params => params['documentUri']),
      filter(uri => !!uri), // Ensure uri is not null or undefined
      tap(uri => this.documentUri = uri),
      switchMap(uri => this._documentService.getDocumentMetadata(uri))
    )
    .subscribe({
      next: (response: IApiResponse<ISimPublicationMetadata>) => {
        if(response.success) {
          this.SIMPublicationMetadata = response.content;
          this.SIMPublicationOverview = response.content.simPublicationOverview;
          this.SIMPublicationDetails = response.content.simPublicationDetails;
          this.SIMPublicationKeyDates = response.content.simPublicationKeyDates;
          this.designation = this.SIMPublicationOverview.designation;
          this.title = this.SIMPublicationDetails.titleFull;
          
          this.loading = false;
        }
      },
      error: _ => {
        console.error("unable to retrieve document metadata");
        this.loading = false;
      }
    });

    this.subscriptions.add(documentMetadata);
  }

  onTabChange(tabId: string) {
    this.selectedTab = tabId;
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

}
